import { canv } from '@/canv/global.js'

export class shapeOffPageConnector {

    constructor() {

    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width - 2 * horizontalPadding;
        var allowedHeight = height * 5/8 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height * 5/8 / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        var r = height / 30;
        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + 2*r, y); // 2*r потому что с просто r немного не правильно отображается угол
        canv.ctx.arcTo(x + width, y, x + width, y + height * 5/8, r);
        canv.ctx.arcTo(x + width, y + height * 5/8, x + width/2, y + height, r);
        canv.ctx.arcTo(x + width/2, y + height, x, y + height * 5/8, r);
        canv.ctx.arcTo(x, y + height * 5/8, x, y, r);
        canv.ctx.arcTo(x, y, x + width, y, r);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="85" height="80" viewBox="0 0 85 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 9.35876C0 4.19006 4.19006 0 9.35876 0H74.87C80.0387 0 84.2288 4.19006 84.2288 9.35876V48.8043C84.2288 51.9334 82.665 54.8554 80.0613 56.5912L47.3057 78.4283C44.1621 80.5239 40.0667 80.5239 36.9231 78.4283L4.16745 56.5912C1.56387 54.8554 0 51.9334 0 48.8043V9.35876Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 2.77778C0.5 1.5198 1.5198 0.5 2.77778 0.5H22.2222C23.4802 0.5 24.5 1.5198 24.5 2.77778V14.4856C24.5 15.2472 24.1194 15.9584 23.4857 16.3808L13.7635 22.8623C12.9984 23.3724 12.0016 23.3724 11.2365 22.8623L1.5143 16.3809C0.880617 15.9584 0.5 15.2472 0.5 14.4856V2.77778Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
